import React, { Component, PureComponent, Fragment } from 'react'
import { Icon } from 'semantic-ui-react'
import moment from 'moment'
import { Map, List, fromJS } from 'immutable'

function exportCsv(data, prefix = 'export') {
  if (!List.isList(data)) data = List()

  // let cellEscape = cell => '"' + String(cell || '').replace(/\r?\n/g, '').replace(/"/g, '""').replace(/\t/g, '') + '"'
  let cellEscape = cell => {
    cell = String(cell || '')
      .replace(/\r?\n/g, '')
      .replace(/"/g, '""')
      .replace(/\t/g, '')

    if (cell.indexOf(';') > -1) cell = `"${cell}"`

    return cell
  }

  let csv = data
    .reduce((rows, row, key) => {
      /* If first row, then create header row */
      if (key === 0) rows = [row.map(i => cellEscape(i.get('title'))).join('; ')]

      return [...rows, row.map(i => cellEscape(i.get('value'))).join('; ')]
    }, [])
    .join('\n')

  let link = document.createElement('a')

  let blob = new Blob([csv], { type: 'text/csv;charset=utf-8' })
  link.setAttribute('href', URL.createObjectURL(blob))
  link.setAttribute('download', `${prefix}-${new Date().toISOString().slice(0, 10)}.csv`)
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

function normalizeItems(items, columns) {
  return items.map(item => {
    return columns.reduce((row, column) => {
      let { name, label } = column

      let content = item.getIn(column.name.split('.'), '')
      if (typeof column.export === 'function') content = column.export.call(null, item, column)

      if (column.date) {
        if (!content) {
          content = '(Aikaa ei ole asetettu)'
        } else if (column.date === 'timeago') {
          content = moment(content, 'YYYY-MM-DD HH:mm:ss.SSSZZ').fromNow()
        } else if (column.date === true) {
          content = moment(content, 'YYYY-MM-DD HH:mm:ss.SSSZZ').format('DD.MM.YYYY - HH:mm')
        } else {
          content = moment(content, 'YYYY-MM-DD HH:mm:ss.SSSZZ').format(column.date)
        }
      }

      if (column.options && column.options[content]) content = column.options[content]

      if (Array.isArray(column.options)) {
        let option = column.options.find(o => o.value === content)
        if (option) content = option.text
      }

      return row.push(
        fromJS({
          title: label || name,
          value: content,
        })
      )
    }, List())
  })
}

export default function DatatableExport({ items, columns, id }) {
  return (
    <div className="datatable-export">
      <button
        className="datatable-export-button datatable-header-action"
        onClick={e => e.preventDefault() & exportCsv(normalizeItems(items, columns), id)}>
        <Icon name="download" />
        <span>Lataa data</span>
      </button>
    </div>
  )
}
